import axios, { AxiosInstance } from "axios";

const heavyHttp: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_WEBADAPTER_URL,
});

export default heavyHttp;
